// ======================================================================
// File Name       : AboutSuperuserEnterpriseRoleDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React from 'react';
import { Modal, Button, Table, Col, Form } from 'react-bootstrap';
import { HYPHEN, MESSAGE_TYPE, MODAL_SIZE } from '../../constants/index';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';

class AboutSuperuserEnterpriseRoleDialog extends React.Component {
  /**
   * Get authority text by number
   * @param {number} authority
   * @return {string}
   */
  getAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '参照のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  getAuthorityDisplayText(authority) {
    switch (authority) {
      case 0:
        return '非表示';
      case 1:
      case 2:
        return '表示';
      default:
        return '';
    }
  }

  render() {
    const {
      showModal,
      onEnterpriseAuthorityAboutOk,
      showDialogEnterpriseRoleSecernId,
      superuserAllEnterpriseRoleList,
    } = this.props;

    const style = {
      background: 'none',
      width: 'auto',
      height: 'auto',
      marginLeft: 0,
      left: 0,
    };

    const superuserEnterpriseRole = superuserAllEnterpriseRoleList.bySecernId[showDialogEnterpriseRoleSecernId];
    const authorityDisplayMapping = Object.keys(superuserEnterpriseRole.enterpriseManagementFunctionAuthorityInfo).reduce(
      (acc, cur) => {
        acc[`${cur}Display`] =
          superuserEnterpriseRole.enterpriseManagementFunctionAuthorityInfo[cur] > 0
            ? MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
            : MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE;
        return acc;
      },
      {},
    );

    superuserEnterpriseRole.managementFunctionAuthorityDisplayInfo = {
      ...authorityDisplayMapping,
    };
    const { enterpriseManagementFunctionAuthorityInfo, managementFunctionAuthorityDisplayInfo } = superuserEnterpriseRole;

    return (
      <Modal
        className="modal-container"
        show={showModal}
        onHide={onEnterpriseAuthorityAboutOk}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={onEnterpriseAuthorityAboutOk} closeButton>
          <Modal.Title className="text-center">ロール設定</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col sm={12}>
            <Form className='form-horizontal'>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4} />
                  <Col sm={4}>画面表示</Col>
                  <Col sm={4}>権限設定</Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>企業管理</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.enterpriseManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.enterpriseManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>サービス設定</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.serviceManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.serviceManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>管理ユーザー</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.superuserManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.superuserManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>ロールと権限</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.superuserRoleManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.superuserRoleManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>企業システム利用実績</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.enterprisePerformanceManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.enterprisePerformanceManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label}>
                  <Col sm={4}>企業向けお知らせ一覧</Col>
                  <Col sm={4}>
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay
                    )}
                  </Col>
                  <Col sm={4}>
                    {managementFunctionAuthorityDisplayInfo.enterpriseNoticeManagementAuthorityDisplay ===
                    MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY
                      ? this.getAuthorityText(enterpriseManagementFunctionAuthorityInfo.enterpriseNoticeManagementAuthority)
                      : HYPHEN}
                  </Col>
                </Col>
              </Form.Group>
            </Form>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="primary" className="margin-10 btn-96" onClick={onEnterpriseAuthorityAboutOk}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AboutSuperuserEnterpriseRoleDialog;
